import { CONSULTATION_COPY } from '../../../../../constants/consultation';

export const HOW_WE_WORK_SECTION = {
  title: 'How We Work',
  subtext:
    'Personalized plans delivered online in a HIPAA-compliant environment. Sessions use\nhypnosis/hypnotherapy and skills training designed to activate change and support\nlasting progress.',
  buttonText: CONSULTATION_COPY.startVideoConsultation,
};
